import React, { useState, useEffect, useCallback } from "react";
import {
  BiCheck,
  BiCopyright,
  BiHash,
  BiRecycle,
  BiTrashAlt,
} from "react-icons/bi";
import { BsFillBookmarksFill, BsGearFill } from "react-icons/bs";
import { BsThreeDotsVertical } from "react-icons/bs";
import { v4 as uuidv4 } from "uuid";
import { RiSurveyFill } from "react-icons/ri";
import { IoHourglassOutline } from "react-icons/io5";

import { connect } from "react-redux";
import axios from "../../../axios";
import * as url from "../../../utils/url";
import * as actionCreators from "../../../modules/actions/index";
import Loading from "../../../hoc/Loading/Loading";


function TrivvyResponseCounter({ user }) {
  const orgObject = user.profile.organizationId;

  return (
    <span>
      {orgObject ? (
        <div>
          <div className="remaining_text mb-3">
          <RiSurveyFill className="mr-1" /> {orgObject.totalTriviaResponsesCount -
              orgObject.submittedTriviaResponsesCount}{" "}
             remaining{" "}
          </div>
          <div className="waiting_text">
          <IoHourglassOutline className="mr-1" /> {orgObject.waitingTriviaResponsesCount} Waiting
          </div>
        </div>
      ) : (
        ""
      )}
    </span>
  );
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    orgChangeSuccess: (data) => dispatch(actionCreators.orgChangeSuccess(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Loading(TrivvyResponseCounter, axios));
